import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useRoute } from '../hooks/useRoute';
import { useGPTGameTrigger } from 'src/EXPERIMENTAL_LIB/gpt/games/hooks/useGPTGameTrigger';

export const LuckyPigeonOpener = () => {
  const navigate = useNavigate();
  const {
    i18n: { language: lang }
  } = useTranslation();
  const { ROUTE } = useRoute();

  const { triggerGPTGame } = useGPTGameTrigger();

  useEffect(() => {
    triggerGPTGame('birdGame', { lang });
    navigate(ROUTE.MAIN.get());
  }, []);

  return <></>;
};
